import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class RatingQueryService {

  public GET_CURRENT_ORDER_RATING_DATA: any;

  public SUBMIT_RATING: any;

  constructor(public apollo: Apollo) {

    this.GET_CURRENT_ORDER_RATING_DATA =
      gql`
       query CHECK_RATING_STATUS_REPORT($insReportId:String!){

            allRatings(condition:{insReportId:$insReportId}) {
              edges {
                node {               
                    rating                 
                    insReportId              
                    createdAt
                    communication
                    punctuality
                    quality
                    reviewPoint              
                }
              }
            }

          }
        `
      ;

    // Mutaion - CREATE_SCHEDULE_REQUEST  detail
    this.SUBMIT_RATING = gql` 
       mutation SUBMIT_RATING($input: CreateRatingInput!) {
            createRating(input: $input) {
                rating{                    
                    rating         
                }
        }
       }
       `;

  }

  // Get rating of this order
  GET_CURRENT_ORDER_RATING() {

    return this.apollo
      .watchQuery({
        query: this.GET_CURRENT_ORDER_RATING_DATA
        ,
        variables:
        {
          'insReportId': window.localStorage.getItem('reportId').trim(),
        },
        fetchPolicy: 'network-only'
      });

  }

  // Submit ratings
  submitRating(ratingData) {

    return this.apollo.mutate({
      mutation: this.SUBMIT_RATING,
      variables: {
        'input': {
          'rating': {
            'createdAt': new Date(),
            'insReportId': window.localStorage.getItem('reportId').trim(),
            'orderId': ratingData.orderId,
            'icId': ratingData.icId,
            'rating': ratingData.ratingRange,
            'reviewPoint': ratingData.reviewPoint,
            'communication': ratingData.communication,
            'punctuality': ratingData.punctuality,
            'quality': ratingData.quality,
          }
        },

      }
    });

  }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/gql-query-mutation/ratings.service.ts